import React from 'react';
import { cn } from '../../lib/utils';
import { MarketplaceCategory } from '../../lib/types';
import { Coffee, Pizza, Utensils, IceCream, Sandwich, Beef, Salad, Wine } from 'lucide-react';
import { useLanguage } from '../../lib/i18n';
interface CategoryChipsProps {
  categories: MarketplaceCategory[];
  activeCategory?: string;
  onSelect?: (categoryId: string) => void;
  className?: string;
}
const getIcon = (iconName: string | null) => {
  const icons: Record<string, React.ElementType> = {
    coffee: Coffee,
    pizza: Pizza,
    utensils: Utensils,
    'ice-cream': IceCream,
    sandwich: Sandwich,
    beef: Beef,
    salad: Salad,
    wine: Wine
  };
  const Icon = iconName && icons[iconName] ? icons[iconName] : Utensils;
  return <Icon className="w-4 h-4" data-id="element-1321" />;
};
export function CategoryChips({
  categories,
  activeCategory,
  onSelect,
  className
}: CategoryChipsProps) {
  const {
    t
  } = useLanguage();
  return <div className={cn('w-full overflow-x-auto pb-4 pt-2 no-scrollbar', className)} data-id="element-1322">
      <div className="flex gap-3 px-4 sm:px-6 lg:px-8 min-w-max" data-id="element-1323">
        <button onClick={() => onSelect?.('')} className={cn('flex items-center gap-2 px-6 py-2.5 rounded-full font-semibold text-sm transition-all duration-200 border', !activeCategory ? 'bg-gradient-to-r from-[#C9A34E] to-[#d4b365] text-white border-[#C9A34E] shadow-lg' : 'bg-[#C9A34E]/10 text-[#C9A34E] border-[#C9A34E]/30 hover:bg-[#C9A34E]/20 hover:border-[#C9A34E]/50')} data-id="element-1324">
          <span data-id="element-1325">{t('all')}</span>
        </button>

        {categories.map(category => <button key={category.id} onClick={() => onSelect?.(category.id)} className={cn('flex items-center gap-2 px-6 py-2.5 rounded-full font-semibold text-sm transition-all duration-200 border', activeCategory === category.id ? 'bg-gradient-to-r from-[#C9A34E] to-[#d4b365] text-white border-[#C9A34E] shadow-lg' : 'bg-[#C9A34E]/10 text-[#C9A34E] border-[#C9A34E]/30 hover:bg-[#C9A34E]/20 hover:border-[#C9A34E]/50')} data-id="element-1326">
            {getIcon(category.icon_name)}
            <span data-id="element-1327">
              {t(`mcat_${category.name.toLowerCase().replace(/\s+/g, '_').replace(/[áéíóú]/g, c => ({
            á: 'a',
            é: 'e',
            í: 'i',
            ó: 'o',
            ú: 'u'
          })[c] || c)}`) || category.name}
            </span>
          </button>)}
      </div>
    </div>;
}